import React, { Component, PropTypes } from 'react';
import { ReactSparkTextInput } from '../../../widgets';
import ModalAssetBrowser from '../../../widgets/ModalAssetBrowser';
import { CATEGORIES, FileService } from '../../../../services/fileUpload/uploadFile';
import store from '../../../../store/Store';
import ConfigurationCheckbox from '../../../widgets/ConfigurationCheckbox';
import './InContextHeaderControl.scss';


class InContextHeaderControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showAssetBrowser: false,
            logoInputKey: 0,
        }
    }
    render() {
        const { currentConfigCopy, isDisabled, level, setConfigText, toggleConfigBoolean } = this.props;
        const logoUrl = _.get(currentConfigCopy, 'inContextHeader.logo.url', '');
        const alwaysShowHotelName = _.get(currentConfigCopy, 'inContextHeader.alwaysShowHotelName', false);

        return (
            <div className="in-context-header-control">
                <h4>In-Context: header</h4>
                <h5 className="no-text-transform">Logo url</h5>
                <div className="in-context-header-control__logo-row">
                    <div className="in-context-header-control__logo-input">
                        <ReactSparkTextInput
                            key={this.state.logoInputKey}
                            label="Logo url"
                            isDisabled={isDisabled}
                            value={logoUrl}
                            onChange={e => {
                                setConfigText('inContextHeader.logo.url', e.target.value ? e.target.value : '');
                            }}
                        />
                    </div>
                    <div className="in-context-header-control__logo-action">
                        <ModalAssetBrowser
                            category={CATEGORIES.IMAGE}
                            isDisabled={isDisabled}
                            store={store}
                            onOpen={isOpen => {
                                this.setState({ showAssetBrowser: isOpen });
                            }}
                            onClose={() => {
                                this.setState({ showAssetBrowser: false });
                            }}
                            open={this.state.showAssetBrowser}
                            onSelect={assets => {
                                if (assets.length >= 1) {
                                    const asset = assets[0];
                                    const url = FileService.assetUrl(
                                        asset.chainid,
                                        asset.hotelid,
                                        null,
                                        level,
                                        asset.filename,
                                        false,
                                        CATEGORIES.IMAGE
                                    );
                                    setConfigText('inContextHeader.logo.url', url);
                                    this.setState(state => ({
                                        showAssetBrowser: false,
                                        logoInputKey: state.logoInputKey + 1
                                    }));
                                }
                            }}
                        />
                    </div>
                </div>
                <br />
                <h5 className="no-text-transform">Hotel Name</h5>
                <div>
                    <ConfigurationCheckbox
                        isDisabled={isDisabled}
                        value={alwaysShowHotelName}
                        code="inContextHeader.alwaysShowHotelName"
                        onChange={toggleConfigBoolean}
                        title="Always Show Hotel Name"
                    />
                </div>
            </div>
        );
    }
}

InContextHeaderControl.propTypes = {
    currentConfigCopy: PropTypes.object.isRequired,
    setConfigText: PropTypes.func.isRequired,
    isDisabled: PropTypes.bool
};

InContextHeaderControl.defaultProps = {
    isDisabled: false
};

export default InContextHeaderControl;



// WEBPACK FOOTER //
// ./src/components/pages/pages/product/InContextHeaderControl.js